/**
 * @file Info circle icon for inline help / disclosure affordances.
 * @module @labcraft/ui/icons/info-circle
 *
 * Inline SVG inheriting `currentColor`. Consumers control size via
 * `width`/`height` props or CSS, color via `color` on a parent.
 */

import type { JSX, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

/**
 * Info-in-circle icon.
 *
 * @param props - Pass-through props for the underlying `<svg>`.
 * @returns The rendered icon.
 */
export function InfoCircleIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 14 14"
      width={14}
      height={14}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}>
      <circle cx={7} cy={7} r={5.5} />
      <line x1={7} y1={6} x2={7} y2={10} />
      <circle cx={7} cy={4.2} r={0.4} fill="currentColor" />
    </svg>
  )
}
